import { ContactsClient } from "modules/BookingCommon/components"

interface Props {
    name: string
    phone: string
    email: string
}

export function UserInfo({ name, phone, email }: Props) {
    return (
        <div className="booking-form">
            <ContactsClient name={name} phone={phone} email={email} />
        </div>
    )
}
